import { Home } from "../../components/backgrounds/Home";
import { TermsV1 } from "../../components/legal/Terms/TermsV1";
import { TermsV2 } from "../../components/legal/Terms/TermsV2";

export const dataCompany = [
  {
    name: "GRUPO EMPRESARIAL ANAV S.A.S",
    nit: "901.582.748-5",
    address: "Calle 79 # 11 - 66, Edificio SPACES",
    email: "ayuda@galilea.co",
  },
];

export function TermsPage() {
  return (
    <div className="relative bg-white overflow-hidden">
      <Home title={"Términos y condiciones"} />
      <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
        <div
          className="relative h-full text-lg max-w-prose mx-auto"
          aria-hidden="true"
        ></div>
      </div>
      <TermsV2 />
    </div>
  );
}
